var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbUpSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3031_2850",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "black",
    fillOpacity: 0.6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3031_2850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 14H5.3335V5.33332L10.0002 0.666656L10.8335 1.49999C10.9113 1.57777 10.9752 1.68332 11.0252 1.81666C11.0752 1.94999 11.1002 2.07777 11.1002 2.19999V2.43332L10.3668 5.33332H14.0002C14.3557 5.33332 14.6668 5.46666 14.9335 5.73332C15.2002 5.99999 15.3335 6.3111 15.3335 6.66666V7.99999C15.3335 8.07777 15.3252 8.1611 15.3085 8.24999C15.2918 8.33888 15.2668 8.42221 15.2335 8.49999L13.2335 13.2C13.1335 13.4222 12.9668 13.6111 12.7335 13.7667C12.5002 13.9222 12.2557 14 12.0002 14ZM4.00016 5.33332V14H1.3335V5.33332H4.00016Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpSelected);
export default __webpack_public_path__ + "static/media/thumb_up_selected.011dfa59f66de9b23f4c704c93c0167c.svg";
export { ForwardRef as ReactComponent };